<template>
  <div class="m_product clearfix">
    <div class="product_head">
      <img src="/static/images/m/back.png" alt="" class="p_back" @click='back'>
      <p class="p_head_name">产品分类</p>
    </div>
    <div class="p_leftmenu_wrap">
      <div class="p_leftmenu">
        <template v-for='item in Category'>
          <div :class="{leftmenu_item:true,active:index==item.id}" @click='index=item.id'>
            <div class="menu_img">
              <img :src="domain+item.icon1" alt="" class="icon1">
              <img :src="domain+item.icon2" alt="" class="icon2">
            </div>
            <p>{{item.name}}</p>
          </div>
        </template>
      </div>
    </div>
    <div class="product_list_wrap animated slideInRight" v-if='data.length>0'>
      <img :src="domain+cate.wap_litpic" alt="">
      <div class="listt_item clearfix" v-for='item in data'>
        <p class="p_title">
          {{item.name}}
        </p>
        <div class="p_item" v-for='child in item.child' v-if='!item.art'>
          <router-link :to='"/m/product/list/"+child.id'>
            <div class="p_item_img">
              <img :src="domain+child.litpic" alt="">
            </div>
            <p>{{child.name}}</p>
          </router-link>
        </div>
        <div class="p_item" v-for='child in item.art' v-if='item.art'>
          <router-link :to='"/m/product/detail/"+child.id'>
            <div class="p_item_img">
              <img :src="domain+child.litpic" alt="">
            </div>
            <p>{{child.title}}</p>
          </router-link>
        </div>
      </div>
    </div>

    <div class="product_list_wrap animated slideInRight" v-if='list.length>0'>
      <img :src="domain+cate.litpic" alt="">
      <div class="listt_item clearfix" >
        <p class="p_title">
          {{cate.name}}
        </p>
        <div class="p_item" v-for='item in list'>
          <router-link :to='"/m/product/detail/"+item.id'>
            <div class="p_item_img">
              <img :src="domain+item.litpic" alt="">
            </div>
            <p>{{item.title}}</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import animatecss from 'animate.css'
export default {
  name: 'app',
  data(){
    return{
      Category:[],
      hots:[],
      domain:'',
      index:'',
      cate:'',
      data:[],
      id:'',
      list:[]
    }
  },
  watch:{
    '$route':function(to,from){
      this.getCategory()
    },
    'index':function(){
      this.data=[]
      this.list=[]
      sessionStorage.setItem('id',this.index)
      this.getCategory2()
    }
  },
  mounted:function(){
    if(!sessionStorage.getItem('id')){
      this.index=1;
    }else{
      this.index=sessionStorage.getItem('id')
    }
    
    this.id = this.$route.params.id
    this.domain=this._routerRoot.domain
    this.getCategory();
  },
  methods:{
    back(){
       window.history.back() 
    },
    getCategory:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        limit:10,
        cid:19,
        status:1
      }))
      .then(response => {
        console.log(response);
        this.Category=response.data.data
        //this.index=this.Category[0].id
        this.getCategory2()
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
    getCategory2:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_Category', this.$qs.stringify({
        cid:this.index
      }))
      .then(response => {
        console.log(response);
        this.cate = response.data.cate
        this.data = response.data.data
        console.log(this.data)
        if(this.data.length==0){
          this.getList()
        }
        /*this.Category=response.data.data
        this.cate = response.data.cate
        this.getparent(this.cate.id)*/ 
        //this.parent=this._routerRoot.parent;

        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
     getList:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=get_product_lists', this.$qs.stringify({
        cid:this.index,
        page:1,
        limit:1000
      }))
      .then(response => {
        console.log(response);
        this.list=response.data.data
        //this.cate = response.data.cate
        //this.getparent(this.cate.id)
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>

  .product_head{
    height: 0.99rem;
    line-height: 0.99rem;
    text-align: center;
    background-color: #f9f9f9;
    position: relative;
    border-bottom: 1px solid #e0e0e0;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .p_head_name{
    font-size: 0.24rem;
    color: #383838;
  }
  .p_head_name:before{
    content: '';
    display: inline-block;
    width: 0.24rem;
    height: 1px;
    background-color: #383838;
    position:relative;
    top: -0.07rem;
    right: 0.07rem;
  }
  .p_head_name:after{
    content: '';
    display: inline-block;
    width: 0.24rem;
    height: 1px;
    background-color: #383838;
    position:relative;
    top: -0.07rem;
    left: 0.07rem;
  }
  .p_back{
    width: 0.13rem;
    position: absolute;
    left: 0.32rem;
    top: 0.37rem;
  }
  .p_leftmenu_wrap{
    overflow: scroll;
    -webkit-overflow-scrolling : touch;
    position: fixed;
    height: 100%;
    left: 0;
    padding-top: 0.99rem;
    width: 1.28rem;
    padding-bottom: 1rem;
    box-sizing: border-box;
    background-color: #fff;
  }
  .p_leftmenu{
  }
  .leftmenu_item{
    height: 1.28rem;
    border-right: 1px solid #eeeeee;
    font-size: 0.18rem;
    color: #666;
    text-align: center;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
  }
  .leftmenu_item.active{
    border-right: 0;
  }
  .product_list_wrap{
    width: 5.12rem;
    box-sizing: border-box;
    float: right;
    margin-top: 0.99rem;
    padding: 0.38rem 0.2rem 1rem 0.18rem
  }
  .menu_img{
    height: 0.5rem;
    position: relative;
    padding-top: 0.25rem;
    padding-bottom: 0.18rem;
  }
  .menu_img img{
    max-height: 100%;
    max-width: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .p_title{
    font-size: 0.18rem;
    color: #3478f7;
    text-align: center;
    padding: 0.37rem 0;
  }
  .p_title:before{
    content: '';
    display: inline-block;
    width: 0.24rem;
    height: 1px;
    background-color: #3478f7;
    position:relative;
    top: -0.04rem;
    right: 0.04rem;
  }
  .p_title:after{
    content: '';
    display: inline-block;
    width: 0.24rem;
    height: 1px;
    background-color: #3478f7;
    position:relative;
    top: -0.04rem;
    left: 0.04rem;
  }
  .p_item{
    width: 33.333%;
    text-align: center;
    font-size: 0.18rem;
    color: #5d5d5d;
    margin-bottom: 0.3rem;
    display: inline-flex;
    justify-content: center;
-webkit-justify-content: center;
align-items:center;
-webkit-align-items: center;
  }
  .p_item>a{
    display: block;
    width: 100%;
  }
  .p_item_img{
    height: 0.7rem;
    margin-bottom: 0.2rem;
  }
  .p_item p{
    color: #5d5d5d;
    line-height: 0.3rem;
  }
  .p_item_img img{
    max-width: 100%;
    height: 100%;
    display: block;
    margin: 0 auto;

  }
  .leftmenu_item .icon2{
    display: none
  }
  .leftmenu_item.active .icon1{
    display: none;
  }
  .leftmenu_item.active .icon2{
    display: block;
  }
  .leftmenu_item.active p{
    color: #3478f7;
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile/product.vue